import Advert from './Advert.vue'

export default Advert
